import { useState } from "react";
import { Box, Grid } from "@mui/material"
import { NoDataFound } from "../../../empty/Index"
// import { SnakeLoader } from "../../../../../core/loader/SnakeLoader"
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { OrderDetails } from "./OrderDetails";

export const Tbody = ({branchOrderData, generateForm}) => {

    const [open, setOpen] = useState(false)
    const [order, setOrder] = useState([])

    const viewOrder = (order)=>{
        setOpen(true)
        setOrder(order)
    }
    return (
        <Box height="100%" width="100%" bgcolor="#FFFFFF" borderRadius="12px" className="overflowY" display="flex" flexDirection="column" gap="12px" p={2}>
            {/* {generateForm.infiniteLoad && 
                <Box height="100%" display="flex" alignItems="center" justifyContent="center">
                    <SnakeLoader size="1rem" bg="#11783C" distance="0.3rem" />
                </Box>
            } */}
            {(!generateForm.infiniteLoad && branchOrderData.length === 0) && <NoDataFound/>}
            {(!generateForm.infiniteLoad && branchOrderData.length > 0) && branchOrderData.map((v,k) => (
                <Grid key={k} container direction="row" sx={{p:2, border:'1px solid #EBEBEB', borderRadius:'10px'}}>
                    <Grid item xs={2}>{v.series_num}</Grid>
                    <Grid item xs={2} textAlign="center">{v.name}</Grid>
                    <Grid item xs={2} textAlign="center">{v.first_name} {v.last_name}</Grid>
                    <Grid item xs={3} textAlign="center">
                        {new Date(v.created_at).toLocaleString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                        })}
                    </Grid>
                    <Grid item xs={2} textAlign="center">{`₱ ${parseFloat(v.total_sales).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</Grid>
                    <Grid item xs={1} textAlign="center"><RemoveRedEyeOutlinedIcon onClick={()=>{viewOrder(v)}} sx={{color: "primary.main", fontSize: 28}}/></Grid>
                </Grid>
            ))}
            {open &&
                <OrderDetails open={open} setOpen={setOpen} orderDetails={order}/>
            }
        </Box>
    )
}